package gr.tech.pdfgenerator.models.user

import kotlinx.serialization.Serializable

@Serializable
data class UserPreview(
    val uuid: String,
    val name: String,
    val email: String,
    var roles: List<String>,
    val imageUrl: String,
)

@Serializable
data class UserProfilePreviewResponse(
    val uuid: String,
    val name: String,
    val email: String,
    val imageUrl: String?,
    val companyName: String?,
    val contactEmail: String?,
    val contactPhone: String?,
    val utility: String?,
    val state: String?,
    val description: String?,
)